// Exemple de script de page, add it to $additional_bottom_scripts = []; on the  page
	/**********************************************/
	/**** HORIZONTAL IMAGE ACCORDION *****/

	  var x = $('.x');
	  var accordion = $('.accordion');

	  var item = $('.accordion__item');


	  var active = $('.accordion .active');
	  var activeSiblings = 2; //il faut metre le numbre de items inactives//active.siblings().length;
	  var margin = 16; //marging betweens images
	  var duration = 1000;

	  var itemLength = item.length;
	  var itemWidth = accordion.width() / itemLength - ( activeSiblings /  itemLength * margin );
	  var activeWidth = (accordion.width() / 100) * (100 - 12 * itemLength) - ( activeSiblings /  itemLength * margin );
	  var notActiveWidth = ( accordion.width() - activeWidth ) / ( activeSiblings ) - (activeSiblings /  itemLength * margin );

	  item.width(itemWidth);
	  item.click( function(){
			//alert('alert');
	    $(this)
	      .addClass('active')
	      .stop(true)
	      .animate({'width': activeWidth + 'px'}, duration)
	      .siblings()
	      .removeClass('active')
	      .stop(true)
	      .animate({'width': notActiveWidth + 'px'}, duration);
	    }/*,function(){
	       $(this).removeClass('active')
	      .stop(true)
	      .animate({'width': itemWidth + 'px'}, duration);
	  }*/);

	/**********************************************/